import React from 'react';
import PracticQuestionSubjects from '../../subjects/PracticQuestionSubjects';

function PracticeQuestions() {

  return (

    <>
     
      <PracticQuestionSubjects 
        name="NCERT-Based Questions (DPP)" 
        link="practice-question-topics" 
        type="dpp" 
      />

    </>
  );
}

export default PracticeQuestions;